module.exports = __webpack_public_path__ + "img/logo.08a7dfb5.png";